export const Field = ({ id, label, error, as: Tag = "input", testid, optional, ...props }) => (
  <div className="flex flex-col gap-2 text-left">
    <label htmlFor={id} className="text-[11px] font-medium uppercase tracking-[0.22em] text-[#9AAABD]">
      {label}
      {optional && <span className="ml-2 normal-case tracking-normal text-[#9AAABD]/60">(optional)</span>}
    </label>
    <Tag
      id={id}
      data-testid={testid}
      aria-invalid={!!error}
      aria-describedby={error ? `${id}-error` : undefined}
      className={`cl-input ${error ? "cl-input-error" : ""}`}
      {...props}
    />
    {error && (
      <p id={`${id}-error`} role="alert" data-testid={`${testid}-error`} className="text-xs text-[#F2A7A0]">
        {error}
      </p>
    )}
  </div>
);

export const Honeypot = ({ value, onChange, testid }) => (
  <div className="cl-honeypot" aria-hidden="true">
    <label>
      Website
      <input
        type="text"
        name="website"
        tabIndex={-1}
        autoComplete="off"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        data-testid={testid}
      />
    </label>
  </div>
);

export const FormError = ({ message, testid }) =>
  message ? (
    <p role="alert" data-testid={testid} className="rounded-xl border border-[#F2A7A0]/30 bg-[#F2A7A0]/5 px-4 py-3 text-sm text-[#F2C4BE]">
      {message}
    </p>
  ) : null;
